import { Routes } from '@angular/router';
import { authGuard, permissionGuard } from './core/auth.guard';
import { ShellComponent } from './pages/shell/shell.page';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./pages/login/login.page').then(m => m.LoginComponent) },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', loadComponent: () => import('./pages/dashboard/dashboard.page').then(m => m.DashboardComponent) },
      {
        path: 'visitors',
        canActivate: [permissionGuard(['v_list', 'v_profile'])],
        loadComponent: () => import('./pages/visitors/visitors.page').then(m => m.VisitorsComponent),
      },
      {
        path: 'rewards',
        canActivate: [permissionGuard(['r_list', 'r_create', 'r_redeem'])],
        loadComponent: () => import('./pages/rewards/rewards.page').then(m => m.RewardsComponent),
      },
      {
        path: 'audit',
        canActivate: [permissionGuard('a_view')],
        loadComponent: () => import('./pages/audit/audit.page').then(m => m.AuditComponent),
      },
      {
        path: 'activations',
        canActivate: [permissionGuard(['c_scans', 'c_list', 'c_create'])],
        loadComponent: () => import('./pages/activations/activations.page').then(m => m.ActivationsComponent),
      },
      {
        path: 'push-notifications',
        canActivate: [permissionGuard(['cnt_events', 'v_list'])],
        loadComponent: () => import('./pages/push-notifications/push-notifications.page').then(m => m.PushNotificationsComponent),
      },
      {
        path: 'content',
        canActivate: [permissionGuard(['cnt_events', 'cnt_banners', 'cnt_stamps', 'cnt_media', 'c_create'])],
        loadComponent: () => import('./pages/content/content.page').then(m => m.ContentComponent),
      },
      {
        path: 'app-info',
        canActivate: [permissionGuard(['cnt_events', 'c_create', 'u_roles'])],
        loadComponent: () => import('./pages/app-info/app-info.page').then(m => m.AppInfoPageComponent),
      },
      { path: 'app-info-faqs', redirectTo: 'app-info', pathMatch: 'full' },
      { path: 'app-info-links', redirectTo: 'app-info', pathMatch: 'full' },
      { path: 'legal-privacy', redirectTo: 'app-info', pathMatch: 'full' },
      { path: 'legal', redirectTo: 'app-info', pathMatch: 'full' },
      { path: 'settings', redirectTo: 'app-info', pathMatch: 'full' },
      {
        path: 'users',
        canActivate: [permissionGuard(['u_list', 'u_roles', 'u_invite'])],
        loadComponent: () => import('./pages/users/users.page').then(m => m.UsersComponent),
      },
      {
        path: 'access-rights',
        canActivate: [permissionGuard(['u_roles', 'u_list'])],
        loadComponent: () => import('./pages/access-rights/access-rights.page').then(m => m.AccessRightsComponent),
      },
      {
        path: 'ota',
        canActivate: [permissionGuard(['u_roles', 'cnt_events', 'cnt_media'])],
        loadComponent: () => import('./pages/ota/ota.page').then(m => m.OtaComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
